import React from 'react'
import PropTypes from 'prop-types'

import {
  StyledBlock,
  StyledButtonDownload,
  StyledCtaButton,
  StyledDivRichText,
  StyledDocuments,
  StyledHeading,
  StyledRichText,
} from './BlockPresentation.styled'
import HeadingSizeEnum from '../../enums/headingSize'
import { getSizeFromDocument } from '../../utils/GetSizeFromDocument'
import ButtonVariantEnum from '../../enums/ButtonVariant'

const BlockPresentation = (props) => {
  const { documents, text, title, className, cta } = props

  const docs = documents?.map((doc, index) => (
    <StyledButtonDownload
      key={index}
      name={doc.name}
      description={getSizeFromDocument(doc)}
      document={doc}
    />
  ))

  return (
    <StyledBlock className={`${className} blockPresentation`}>
      {title && <StyledHeading label={title} size={HeadingSizeEnum.h2} />}
      <StyledDivRichText $hasDocument={documents}>
        {text && <StyledRichText html={text.content} />}
      </StyledDivRichText>
      {documents && <StyledDocuments>{docs}</StyledDocuments>}
      {cta && !documents && (
        <StyledCtaButton
          label={cta.label}
          to={cta.url}
          variant={ButtonVariantEnum.primary}
        />
      )}
    </StyledBlock>
  )
}

BlockPresentation.propTypes = {
  documents: PropTypes.array,
  text: PropTypes.object,
  title: PropTypes.string,
  cta: PropTypes.object,
}

export default BlockPresentation
